// hooks/useMembers.js
import { useState, useEffect } from "react";
import { useHygraph } from "./useHygraph";

export const useMembers = () => {
  const [numSocis, setNumSocis] = useState(0);
  const { fetchFromHygraph, loading, error } = useHygraph();

  const getNumSocis = async () => {
    const query = `
      {
        socis {
          numero
        }
      }
    `;

    try {
      const data = await fetchFromHygraph(query);

      if (data && data.socis && data.socis.length > 0) {
        setNumSocis(data.socis[0].numero);
      }
    } catch (err) {
      console.error("Error fetching members:", err);
    }
  };

  useEffect(() => {
    getNumSocis();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    numSocis,
    loadingMembres: loading,
    errorMembres: error,
    refreshMembres: getNumSocis,
  };
};
